export default function ImpressumPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-12">
      <h1 className="mb-8 text-3xl font-bold">Impressum</h1>
      <div className="prose">
        <p>
          <strong>Angaben gemäß § 5 TMG</strong>
        </p>

        <p>
          raydak GmbH
          <br />
          Kalifenweg 48
          <br />
          70567 Stuttgart
        </p>

        <p>
          Handelsregister: HRB 782768
          <br />
          Registergericht: Amtsgericht Stuttgart
        </p>

        <p>
          <strong>Vertreten durch:</strong>
        </p>
        <p>
          Vincent Link
          <br />
          Eduard Marbach
        </p>

        <h2>Kontakt</h2>
        <p>
          E-Mail: <a href="mailto:hello@raydak.de">hello@raydak.de</a>
        </p>

        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          <br />
          DE350153687
        </p>

        <h2>Verbraucher­streit­beilegung/Universal­schlichtungs­stelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren
          vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </div>
  );
}
